<template>
  <div class="bc-white padding-20 br-4">
    <el-row>
      <el-col :span="24" class="ta-right">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="add"
        >新增菜单
        </el-button>
      </el-col>
    </el-row>
    <el-table
      height="calc(100vh - 240px)"
      :expand-row-keys="tableData.map(item => item.id)"
      class="mt-20"
      row-key="id"
      border
      :data="tableData"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column align="left" prop="title" label="菜单名称" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column align="center" label="菜单路由" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.href || scope.row.authority }}
        </template>
      </el-table-column>
      <el-table-column width="120" align="center" prop="sort" label="排序号"></el-table-column>
      <el-table-column width="120" align="center" label="类型" prop="Type">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" v-if="scope.row.type === 0">目录</el-button>
          <el-button size="mini" v-if="scope.row.type === 1">菜单</el-button>
          <el-button size="mini" v-if="scope.row.type === 2">按钮</el-button>
        </template>
      </el-table-column>
      <el-table-column width="240" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="delRow(scope.row)"
          ><span class="color-danger">删除</span>
          </el-button>
          <el-button
            type="text"
            @click="editRow(scope.row)"
          >编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      append-to-body
      size="auto"
      :title="drawer.title"
      :visible.sync="drawer.show">
      <el-form :model="drawer.form" ref="ruleForm" label-width="100px" class="form">
        <el-form-item label="菜单类型：" prop="type" :rules="{required: true, message: '请选择菜单类型', trigger: 'change'}">
          <el-radio-group v-model="drawer.form.type">
            <el-radio :label="0">目录</el-radio>
            <el-radio :label="1">菜单</el-radio>
            <el-radio :label="2">权限</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="drawer.form.type === 2">
          <el-form-item label="权限名称：" prop="name" :rules="{required: true, message: '请输入权限名称', trigger: 'blur'}">
            <el-input v-model="drawer.form.name" placeholder="请输入权限名称"></el-input>
          </el-form-item>
          <el-form-item label="权限接口：" prop="permission" :rules="{required: true, message: '请输入权限接口', trigger: 'blur'}">
            <el-input v-model="drawer.form.permission" placeholder="请输入权限接口"></el-input>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="菜单名称：" prop="name" :rules="{required: true, message: '请输入菜单名称', trigger: 'blur'}">
            <el-input v-model="drawer.form.name" placeholder="请输入菜单名称"></el-input>
          </el-form-item>
          <el-form-item label="菜单路由：" prop="path" :rules="{required: true, message: '请输入菜单路由', trigger: 'blur'}">
            <el-input v-model="drawer.form.path" placeholder="请输入菜单路由"></el-input>
          </el-form-item>
        </template>
        <template v-if="drawer.form.type === 1">
          <el-form-item label="组件名称：" prop="componentName"
                        :rules="{required: true, message: '请输入组件名称', trigger: 'blur'}">
            <el-input v-model="drawer.form.componentName" placeholder="请输入组件名称"></el-input>
          </el-form-item>
          <el-form-item label="组件路径：" prop="componentPath"
                        :rules="{required: true, message: '请输入组件路径', trigger: 'blur'}">
            <el-input v-model="drawer.form.componentPath" placeholder="请输入组件路径"></el-input>
          </el-form-item>
        </template>
        <el-form-item v-if="drawer.form.type === 0" label="菜单图标：" prop="iconUrl"
                      :rules="{required: true, message: '请选择菜单图标', trigger: 'change'}">
          <el-popover
            v-model="showPopover"
            placement="right"
            width="400"
            trigger="click">
            <div class="icon-list">
              <i @click="chooseIcon(item)" class="iconfont" :class="`${item}`" v-for="item in iconList" :key="item"></i>
            </div>
            <el-input placeholder="请选择菜单图标" readonly v-model="drawer.form.iconUrl" slot="reference">
              <i v-if="showIcon" slot="prefix" class="iconfont" :class="`${drawer.form.iconUrl}`"></i>
            </el-input>
          </el-popover>
        </el-form-item>
        <el-form-item label="显示排序：" prop="sort" :rules="{required: true, message: '请输入排序', trigger: 'blur'}">
          <el-input-number v-model="drawer.form.sort" controls-position="right" :min="1"/>
        </el-form-item>
        <el-form-item
          label="上级菜单："
          prop="parentId"
          v-if="drawer.form.type === 1"
          :rules="{required: true, message: '请选择上级菜单', trigger: 'blur'}">
          <el-select v-model="drawer.form.parentId" placeholder="请选择上级菜单">
            <el-option
              v-for="(item,index)  in tableData"
              :key="index"
              :label="item.title"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="上级菜单："
          prop="parentId"
          v-if="drawer.form.type === 2"
          :rules="{required: true, message: '请选择上级菜单', trigger: 'blur'}">
          <el-cascader
            @change="(e) => {drawer.form.parentId = e[e.length-1]}"
            v-model="drawer.form.parentId"
            :options="cascaderList"
            :props="{ expandTrigger: 'hover' }"></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-button :loading="submitLoading" type="primary" @click="submitForm('ruleForm')">确认</el-button>
          <el-button @click="drawer.show = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'MenuManage', // 菜单管理
  components: {},
  props: {},
  data () {
    return {
      submitLoading: false,
      id: null, // 菜单id
      cascaderList: [],
      showPopover: false,
      showIcon: false,
      iconList: [
        'icon-auto',
        'icon-all',
        'icon-data',
        'icon-gift',
        'icon-integral',
        'icon-nav-list',
        'icon-attachent',
        'icon-calendar',
        'icon-category',
        'icon-code',
        'icon-company',
        'icon-ali-clould',
        'icon-copy',
        'icon-connections',
        'icon-customization',
        'icon-email',
        'icon-folder',
        'icon-feeds',
        'icon-phone',
        'icon-viewlist',
        'icon-set',
        'icon-vip',
        'icon-tradingdata',
        'icon-kehupandian',
        'icon-jiehui',
        'icon-xinxibar_zhanghu',
        'icon-zijin',
        'icon-tongxunlu'
      ],
      drawer: {
        title: '',
        show: false,
        form: {
          componentName: null,
          componentPath: null,
          hidden: 0,
          iconUrl: '',
          name: null,
          parentId: null,
          path: '',
          permission: null,
          shortcutUrl: null,
          sort: 1,
          type: 0
        }
      },
      deptOptions: [],
      tableData: []
    }
  },
  filters: {},
  computed: {},
  watch: {},
  methods: {
    /**
     * 提交表单
     * @param formName
     */
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            authority: this.drawer.form.permission,
            componentName: this.drawer.form.componentName,
            componentPath: this.drawer.form.componentPath,
            href: this.drawer.form.path,
            icon: this.drawer.form.iconUrl,
            parentId: this.drawer.form.parentId,
            sort: this.drawer.form.sort,
            title: this.drawer.form.name,
            type: this.drawer.form.type
          }
          this.submitLoading = true
          if (this.id) {
            this.$api.menu.editMenu(Object.assign({ id: this.id }, data)).then(res => {
              this.$message.success('编辑成功')
              this.drawer.show = false
              this.getTableData()
              this.submitLoading = false
            }).catch(() => {
              this.submitLoading = false
            })
          } else {
            this.$api.menu.addMenu(data).then(res => {
              this.$message.success('添加成功')
              this.drawer.show = false
              this.getTableData()
              this.submitLoading = false
            }).catch(() => {
              this.submitLoading = false
            })
          }
        }
      });
    },
    /**
     * 选择图标
     * @param item
     */
    chooseIcon (item) {
      this.showPopover = false
      this.showIcon = true
      this.drawer.form.iconUrl = item
    },
    /**
     * 新增菜单
     */
    add () {
      this.id = null
      this.drawer.form = {
        componentName: null,
        componentPath: null,
        hidden: 0,
        iconUrl: '',
        name: null,
        parentId: null,
        path: '',
        permission: null,
        shortcutUrl: null,
        sort: 1,
        type: 0
      }
      this.drawer.title = '新增菜单'
      this.drawer.show = true
    },
    /**
     * 删除
     * @param row
     */
    delRow (row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.menu.delMenu([row.id]).then(res => {
          this.$message.success('删除成功')
          this.getTableData()
        })
      }).catch(() => {
      });
    },
    /**
     * 编辑
     * @param row
     */
    editRow (row) {
      this.$api.menu.getMenuInfo({ id: row.id }).then(res => {
        this.drawer.title = '编辑菜单'
        this.id = res.id
        this.drawer.form.permission = res.authority
        this.drawer.form.componentName = res.componentName
        this.drawer.form.componentPath = res.componentPath
        this.drawer.form.path = res.href
        this.drawer.form.iconUrl = res.icon
        this.drawer.form.parentId = res.parentId
        this.drawer.form.sort = res.sort
        this.drawer.form.name = res.title
        this.drawer.form.type = res.type
        this.showIcon = true
        this.drawer.show = true
      })
    },
    getTableData () {
      this.$api.menu.getMenuList().then(res => {
        this.tableData = res || []
        this.cascaderList = res.map(item => {
          return {
            value: item.id,
            label: item.title,
            children: item.children ? item.children.map(_item => {
              return {
                value: _item.id,
                label: _item.title
              }
            }) : []
          }
        })
      })
    }
  },
  beforeCreate () {
  },
  created () {

  },
  beforeMount () {
  },
  mounted () {
    this.getTableData()
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.form {
  width: 400px;
  padding: 20px;
}

.icon-list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  i {
    cursor: pointer;
    font-size: 36px;
    margin: 8px;
  }
}
</style>
